import AboutPageShell from '@/components/landing/about-page-shell';

export default function AboutHistory() {
    return (
        <AboutPageShell
            title="History"
            description="Trace the story of Northeastern College from its foundation in 1941 to its development as a long-standing educational institution in the valley."
            
        >
            <div className="bg-card border-border group overflow-hidden rounded-2xl border shadow-sm">
                <div className="md:flex">
                    <div className="relative flex flex-col items-center justify-center bg-[#0A7A35] p-8 text-white md:w-1/4">
                        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:1.5rem_1.5rem]" />
                        <span className="relative z-10 text-xs font-bold tracking-widest uppercase opacity-80">Established 1941</span>
                    </div>
                    <div className="p-6 md:w-3/4 md:p-10">
                        <h2 className="text-foreground mb-4 text-xl font-bold md:text-2xl">Historical Background</h2>
                        <div className="text-muted-foreground space-y-4 text-sm leading-relaxed md:text-base">
                            <p>
                                The Northeastern College Institute, now the Northeastern College, was founded in 1941 by educationally-minded citizens
                                Atty. Francisco E. Pascual, his wife Doña Emeteria Bautista Pascual, and Mr. Leon Cadaoas, all residents of Santiago,
                                Isabela. The Institute, the first to offer secondary education in the province, originally started with first and
                                second year levels, with Doña Emeteria B. Pascual serving as both classroom teacher and principal.
                            </p>
                            <p>
                                When World War II broke out in December 1941, operations were temporarily suspended. In August 1945, the school
                                resumed operations in a rented building in Barangay Dubinan, this time offering complete secondary education. From
                                1945 to 1948, enrollment significantly increased, prompting the construction of a two-storey building on its present
                                site.
                            </p>
                            <p>
                                The success of the early years led to the opening of the college department, initially offering Bachelor of Science in
                                Education, Commerce, and General Associate in Arts, with Mr. Vicente P. Salvador as the first college dean. This also
                                led to the opening of a complete elementary department to serve as a training ground for teacher trainees.
                            </p>
                            <p>
                                Today, Northeastern College offers 15 undergraduate courses, including Nursing, Midwifery Education, Information
                                Technology, and Mass Communication, as well as five postgraduate programs and six computer short-term courses. From
                                its humble beginnings, NC now stands as one of the strongest educational institutions in the valley.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </AboutPageShell>
    );
}
